<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <router-link :to="{ name: 'FicheCoureur' }">
              <v-btn color="primary-dark" density="compact" variant="outlined">
                <v-icon left>mdi-arrow-left</v-icon>
                Retour à ma fiche
              </v-btn>
            </router-link>
            <h3 class="mt-3 mb-4 font-weight-bold">Historique de mes transactions - {{ mainStore.module.nom }}</h3>

            <div class="bg-grey_1 bordered rounded-t shadowed mb-4" v-for="commande in historique.list"
              :key="commande.id">
              <div class="d-flex justify-space-between bg-darkblue px-3 py-3 rounded-t shadowed">
                <div class="text-h5">Commande n°{{ commande.uuid }}</div>
                <div class="text-body"><v-chip v-if="commande.statut == 'PAID'" class="bg-green" density="compact">
                    Payée </v-chip></div>
              </div>

              <div class="pa-2" v-for="transaction in get_paid_transactions(commande)" :key="transaction.id">
                <div class="text-subtitle-1">
                  <v-icon color="primary-dark">mdi-plus</v-icon><i>Référence de la transaction : {{ transaction.uuid
                    }}</i>
                </div>
                <div>Paiement de {{ transaction.prix }}€ le
                  {{ $moment(transaction.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>

              </div>
              <div class="pa-2" v-for="refund in get_refunds(commande)" :key="refund.index">
                <div class="text-subtitle-1">
                  <v-icon color="primary-dark">mdi-minus</v-icon><i>Remboursement sur l'inscription de {{
                    refund.inscription_nom }}</i>
                </div>
                <div>Remboursement de {{ refund.amount_refunded }}€</div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import UserService from "@/services/user.service.js";
export default {
  data() {
    return {
      historique: {},
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    get_paid_transactions(commande) {
      let list_transactions = [];
      for (let i = 0; i < commande.list_transactions.length; i++) {
        if (commande.list_transactions[i].statut == "PAID") {
          list_transactions.push(commande.list_transactions[i]);
        }
      }
      return list_transactions;
    },
    get_refunds(commande) {
      let list_refunds = [];
      for (let i = 0; i < commande.list_commandes_inscriptions_coureur.length; i++) {
        for (let j = 0; j < commande.list_commandes_inscriptions_coureur[i].inscriptions.length; j++) {
          for (let k = 0; k < commande.list_commandes_inscriptions_coureur[i].inscriptions[j].refunds.length; k++) {
            let ref = commande.list_commandes_inscriptions_coureur[i].inscriptions[j].refunds[k];
            ref.inscription_nom = commande.list_commandes_inscriptions_coureur[i].inscriptions[j].nom + " " + commande.list_commandes_inscriptions_coureur[i].inscriptions[j].prenom;
            list_refunds.push(commande.list_commandes_inscriptions_coureur[i].inscriptions[j].refunds[k]);
          }
        }
      }

      return list_refunds;
    },
  },
  async created() {
    if (!this.mainStore.authUser.isLogged) {
      this.$router.push({ name: "FicheCoureur" });
    }
    this.historique = await UserService.getFiche(this.mainStore.module.id);
  },
};
</script>

<style lang="scss" scoped></style>